import { render, staticRenderFns } from "./ExamActionButton.vue?vue&type=template&id=3bed3504&"
import script from "./ExamActionButton.vue?vue&type=script&lang=js&"
export * from "./ExamActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports